import { FormConfig } from '@lbcamden/lib-react';
import { z } from 'zod';

import { commonFormConfig, commonFormSchema } from '../config';

export type RecordAssessmentFormValues = z.infer<typeof formSchema>;

export const formSchema = z.object({
  replacementNeeded: z.enum(['Yes', 'No']),
  ...commonFormSchema.shape,
});

export const formConfig: FormConfig<RecordAssessmentFormValues> = {
  fieldConfigs: {
    ...commonFormConfig.fieldConfigs,
    replacementNeeded: {
      label: 'Is a replacement PCFRA needed?',
    },
  },
};
